import { comparisonHighlights } from '../../../mocks/homepage';

export default function WhyTrustUs() {
  return (
    <section className="py-24 bg-carbon-900 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-neon mb-3 block">
              Why Us
            </span>
            <h2 className="text-4xl font-bold text-white mb-6 tracking-tight">
              Curated for you
            </h2>
            <p className="text-sm text-white/40 leading-relaxed mb-10">
              Our team of experts tests and reviews every product before recommending it.
              We compare pricing, features, support quality, and real user feedback to give you
              the most accurate picture.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {comparisonHighlights.map((item) => (
                <div key={item.title} className="flex gap-4">
                  <div className="w-10 h-10 bg-neon/10 border border-neon/20 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-neon text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-white mb-1">
                      <a href="#" className="hover:text-neon transition-colors">{item.title}</a>
                    </h4>
                    <p className="text-xs text-white/40 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[480px] overflow-hidden border border-white/5">
              <img
                src="https://public.readdy.ai/ai/img_res/dd5a5856b9b89c49bbf2bf5dc4ab895a.jpg"
                alt="Our review process"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="absolute -bottom-6 -left-6 bg-carbon-950 p-5 border border-white/10">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-neon/10 flex items-center justify-center">
                  <i className="ri-check-double-line text-neon text-xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-white">2,400+</div>
                  <div className="text-xs text-white/40">Products Reviewed</div>
                </div>
              </div>
            </div>

            <div className="absolute -top-4 -right-4 bg-carbon-950 p-5 border border-white/10">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-neon/10 flex items-center justify-center">
                  <i className="ri-user-heart-line text-neon text-xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-white">98%</div>
                  <div className="text-xs text-white/40">User Satisfaction</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
